import { render } from "./QuickTable.vue?vue&type=template&id=70327e3f&scoped=true"
import script from "./QuickTable.vue?vue&type=script&lang=js"
export * from "./QuickTable.vue?vue&type=script&lang=js"

import "./QuickTable.vue?vue&type=style&index=0&id=70327e3f&lang=scss&scoped=true"

import exportComponent from "/Users/xujunfeng/Desktop/project/school/digital_factory_server/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70327e3f"]])

export default __exports__